import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/vercel/path0/src/app/auth/new-account/ui/RegisterForm.tsx");
